import { SetState, GetState } from 'zustand';
import { ITransaction } from '../types';

interface IDashboardData {
    uncategorizedTransactionList: ITransaction[];
    uncategorizedTotalNumOfRecords: number;
    taxSaving: number;
    latestTransactions: ITransaction[];
}

export interface IDashboardSlice {
    currentDashboardData: IDashboardData,
    setCurrentDashboardData: (data: IDashboardData) => void;
    getCurrentDashboardData: () => IDashboardData,
    resetDashboardDataSlice: () => void;
}

const createDashboardSlice = (set: SetState<IDashboardSlice>, get: GetState<IDashboardSlice>) => ({
  currentDashboardData: {
    uncategorizedTransactionList: [],
    uncategorizedTotalNumOfRecords: Number.MIN_VALUE,
    taxSaving: -1,
    latestTransactions: [],
  },
  resetDashboardDataSlice: () => {
    set({
      currentDashboardData: {
        uncategorizedTransactionList: [],
        uncategorizedTotalNumOfRecords: Number.MIN_VALUE,
        taxSaving: -1,
        latestTransactions: [],
      },
    });
  },
  setCurrentDashboardData: (data: IDashboardData) => {
    set({ currentDashboardData: data });
  },
  getCurrentDashboardData: () => get().currentDashboardData,
});
export default createDashboardSlice;
